import { AppBar, Box, Button, Grid, Toolbar, useTheme } from "@mui/material";
import {
	BackdropCircularProgress,
	DeleteConfirmationDialog,
	EmptyList,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDialog,
	EnhancedDropDownRHF,
	EnhancedSnackbar,
	RHookFormNumberField,
	RouterLinkButton,
} from "@websential/cosmic-v20";
import { FormProvider, useForm } from "react-hook-form";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	PAYROLL_LIST_SCREEN_SLUG,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../common/constants";
import { IResponse, IServerError } from "../../models/common";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { clearSelectedINVOICE, setSelectedINVOICE } from "../../store/actions/invoiceReportActions";
import { formatDate, formatThousandSeperatorWithTwoFixedAmount, savePdfAsFile, sortDDLByLabel, useNavigateToLogout } from "../../common/Common";
import {
	setSelectedActivityLogActions,
	setSelectedDrawerMenu,
	setSelectedStickyNavBar,
} from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { AdminClientRoutesComponent } from "../RoleBasedLeftMenu/routes/AdminClientRoutes";
import { CalculatedOffCyclePayrollDataGrid } from "./CalculatedOffCyclePayrollDataGrid";
import { CalculatedOffCyclePayrollSetupHeaderPanel } from "./Panels/CalculatedOffCyclePayrollSetupHeaderPanel";
import { CalculatedOffCyclePayrollSetupToolbar } from "./CalculatedOffCyclePayrollSetupToolbar";
import { ClientRoutesComponent } from "../RoleBasedLeftMenu/routes/ClientRoutes";
import { ClientService } from "../../services";
import { CountryService } from "../../services/common/CountryService";
import { DepartmentsService } from "../../services/DepartmentsService";
import { EmployeeService } from "../../services/EmployeeService";
import { IAppState } from "../../store/reducers";
import { IGetListRequest } from "../../models";
import { OffCyclePayrollAddEmployeePanel } from "./Panels/OffCyclePayrollAddEmployeePanel";
import { OffCyclePayrollDataGrid } from "./OffCyclePayrollDataGrid";
import { OffCyclePayrollService } from "../../services/OffCyclePayrollService";
import { OffCyclePayrollSetupHeaderPanel } from "./Panels/OffCyclePayrollSetupHeaderPanel";
import { OffCyclePayrollSetupToolbar } from "./OffCyclePayrollSetupToolbar";
import { PrimeDataGridWithColumnToggled } from "../PrimeDataGridWithColumnToggled";
import { SalaryProfileService } from "../../services/SalaryProfileService";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { GeneralSettingsService } from "../../services/GeneralSettingsService";

export interface IOffCyclePayroll { }
const PAYROLL_LIST_QUERY_KEY = "offCyclePayroll-list";
const CALCULATED_PAYROLL_LIST_QUERY_KEY = "calculated-offCyclePayroll-list";
const PAY_FREQUENCY_DDL_LIST_QUERY_KEY = "pay-frequency-ddl";
const PAYROLL_PERIODS_DDL_LIST_QUERY_KEY = "offCyclePayroll-periods-ddl";
const LABALS_DDL_LIST_QUERY_KEY = "offCyclePayroll-labels-ddl";
const DEPARTMENTS_DDL_LIST_QUERY_KEY = "department-ddl";
const ASSIGN_AND_UNASSIGNED_EMPLOYEE_DATA_QUERY_KEY = "assigned-unassinged-employee-data-record";
const useGetPayFrequencyDDL = (clientId: string, taxYear: number) =>
	useQuery({
		queryKey: [PAY_FREQUENCY_DDL_LIST_QUERY_KEY, clientId, taxYear],
		queryFn: (data) => {
			return EmployeeService.getPayFrequencyDDL(clientId, taxYear);
		},
		refetchOnWindowFocus: false,
	});

const useGetOffCyclePayrollPeriodsDDL = (
	clientId: string, payPeriodId: string | null, taxYear: number
) =>
	useQuery({
		queryKey: [PAYROLL_PERIODS_DDL_LIST_QUERY_KEY, clientId, payPeriodId, taxYear],
		queryFn: (data) => {
			return OffCyclePayrollService.getOffCyclePayrollPeriodsDDL(clientId, payPeriodId, taxYear);
		},
		refetchOnWindowFocus: false,
	});

const useGetLabelsDDL = (
	clientId: string, payPeriodId: string | null, taxYear: number, paymentType: number
) =>
	useQuery({
		queryKey: [LABALS_DDL_LIST_QUERY_KEY, clientId, payPeriodId, taxYear, paymentType],
		queryFn: (data) => {
			return OffCyclePayrollService.getLabelsDDL(clientId, payPeriodId, taxYear, paymentType);
		},
		refetchOnWindowFocus: false,
	});

const useGetVocationalEarningsList = (clientId: string) =>
	useQuery({
		queryKey: ["vocational-earnings-list"],
		queryFn: () => {
			return OffCyclePayrollService.getVocationalEarningsList(clientId);
		},
		refetchOnWindowFocus: false,
	});
const useGetDepartmentsDDL = (clientId: string) =>
	useQuery({
		queryKey: ["deaprtments-ddl", clientId],
		queryFn: () => {
			return DepartmentsService.getGetDepartmentsDDL(clientId);
		},
		refetchOnWindowFocus: false,
	});
const useGetOffCyclePayrollTableData = (
	clientId: string,
	payPeriodFrequencyId: string | null,
	paymentType: number,
	label: string | null,
	// payPeriodEndDate: string | null,
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [
			PAYROLL_LIST_QUERY_KEY,
			clientId,
			payPeriodFrequencyId,
			paymentType,
			label,
			// payPeriodEndDate,
			params
		],
		queryFn: (data) => {
			return OffCyclePayrollService.getOffCyclePayroll(
				clientId,
				payPeriodFrequencyId,
				paymentType,
				label,
				// payPeriodEndDate,
				params,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});


const useGetCalculatedOffCyclePayrollTableData = (
	clientId: string,
	payPeriodFrequencyId: string | null,
	label: string | null,
	paymentType: number,
	// payPeriodStarDate: string | null,
	// payPeriodEndDate: string | null,
	params: IGetListRequest,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [
			CALCULATED_PAYROLL_LIST_QUERY_KEY,
			clientId,
			payPeriodFrequencyId,
			label,
			paymentType,
			// payPeriodStarDate,
			// payPeriodEndDate,
			params
		],
		queryFn: (data) => {

			return OffCyclePayrollService.getCalculatedOffCyclePayroll(
				clientId,
				payPeriodFrequencyId,
				label,
				paymentType,
				// payPeriodStarDate,
				// payPeriodEndDate,
				params,
				navigateToLogout
			);
		},
		refetchOnWindowFocus: false,
	});

const EDR_EARNINGS_AND_TIME_FORMAT_DATA_QUERY_KEY =
	"edr-earnings-single-data-record";
const useGetEDREarningsAndTimeFormatData = (
	clientId: string,
	taxYear: number
) =>
	useQuery({
		queryKey: [EDR_EARNINGS_AND_TIME_FORMAT_DATA_QUERY_KEY],
		queryFn: (data) => {
			return SalaryProfileService.getEDREarningsAndTimeFormatData(
				clientId,
				taxYear
			);
		},
		refetchOnWindowFocus: false,
	});

const useGetOffCyclePayrollAddEmployeePanels = (
	clientId: string,
	taxYear: number,
	selectedPayPeriodId: string | undefined | null,
	payPeriodEndDate: string | undefined | null,
	paymentType: number,
	label: string,
) =>
	useQuery({
		queryKey: [ASSIGN_AND_UNASSIGNED_EMPLOYEE_DATA_QUERY_KEY, clientId, selectedPayPeriodId, payPeriodEndDate, paymentType],
		queryFn: (data) => {
			return OffCyclePayrollService.getOffCyclePayrollAddEmployeePanel(clientId, taxYear, selectedPayPeriodId, payPeriodEndDate, paymentType, label);
		},
		refetchOnWindowFocus: false,
		enabled: false
	});


const CLIENT_INFO_DATA_QUERY_KEY = "client-info-data-record";
const useGetClientInformationById = (
	id: string | undefined,
	navigateToLogout: (path: string) => void
) =>
	useQuery({
		queryKey: [CLIENT_INFO_DATA_QUERY_KEY, id, navigateToLogout],
		queryFn: (data) => {
			return ClientService.getSimpleClientById(id, navigateToLogout);
		},
		refetchOnWindowFocus: false,
	});

	const GENERAL_SETTING_INFO_DATA_QUERY_KEY = "general-settings-info-data-record";
	const useGetGeneralSettingsData = (
		clientId: string,
		navigateToLogout: (path: string) => void
	) =>
		useQuery({
			queryKey: [GENERAL_SETTING_INFO_DATA_QUERY_KEY, clientId, navigateToLogout],
			queryFn: () => {
				return GeneralSettingsService.getByClientId(clientId, navigateToLogout);
			},
			refetchOnWindowFocus: false,
		});

export const OffCyclePayrollSetup: React.FC<IOffCyclePayroll> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const taxYear = useSelector((state: IAppState) => state.taxYear.year);
	// const companyInfo = useSelector((state: IAppState) => state.dashboardApisData.client_detail);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const storedInvoiceNoId = useSelector((state: IAppState) => state.invoice.id);
	const navigateToLogout = useNavigateToLogout();
	const { AdminClientRoutes } = AdminClientRoutesComponent();
	const { ClientRoutes } = ClientRoutesComponent();
	const [showAddRemoveEmployees, setShowAddRemoveEmployees] = useState<boolean>(false);

	const screenPermissions = useSelector((state: IAppState) => state.drawerMenu.screenPermissions);
	const offCyclePayrollScreenPermissions = screenPermissions.find((x: any) => x.url === '/payroll/off-cycle')


	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [loadingData, setIsLoading] = useState(false);
	const [selectedPayPeriodId, setSelectedPayPeriodId] = useState<null | string>(null);
	const [selectedpayPeriodIndex, setSelectedPayPeriodIndex] = useState<null | number>(null);
	const [payPeriodStarDate, setPayPeriodStarDate] = useState<null | string>(null);
	const [payPeriodEndDate, setPayPeriodEndDate] = useState<null | string>(null);
	const [selectedLabel, setSelectedLabel] = useState<null | string>(null);
	const [paymentType, setPaymentType] = useState<number>(200);
	const [selectedRowsValues, setSelectedRowsValues] = useState([]);
	const [offCyclePayrollSetupTableData, setOffCyclePayrollTableData] =
		useState([]);
	const [remittanceFrequencyId, setRemittanceFrequencyId] = useState(undefined);

	const [addEmployee, setAddEmployee] = useState(false);
	const [moveEmployeeFirstPanelItems, setMoveEmployeeFirstPanelItems] =
		useState([]);
	const [moveEmployeeSecondPanelItems, setMoveEmployeeSecondPanelItems] =
		useState([]);

	const formMethods = useForm<any>({
		// resolver: yupResolver(ValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	const labelFieldValue = formMethods.watch("label");
	const labelFieldDDLValue = formMethods.watch("labelDDL");



	const [queryParamsOffCyclePayrollData, setQueryParamsOffCyclePayrollData] = useState<IGetListRequest>({
		search_query: "",
		order_by: "firstName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});
	const [queryParamsCalculatedOffCyclePayrollData, setQueryParamsCalculatedOffCyclePayrollData] = useState<IGetListRequest>({
		search_query: "",
		order_by: "firstName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const { isPending: isPendingGeneralSettingsInformationById, data: general_settings } = useGetGeneralSettingsData(
		clientId,
		navigateToLogout
	);


	const { isPending: isPendingPayFrequencyDDL, data: payFrequencyDDLItems } =
		useGetPayFrequencyDDL(clientId, taxYear);

	useEffect(() => {
		if (payFrequencyDDLItems && payFrequencyDDLItems.length === 1) {
			setSelectedPayPeriodId(payFrequencyDDLItems[0].value)
			formMethods.setValue('payFrequencyDDLItems', payFrequencyDDLItems[0].value)
			setShowAddRemoveEmployees(true)
			let path = `/payroll/off-cycle/${payFrequencyDDLItems[0].value}`
			navigate(path)
		}
	}, [payFrequencyDDLItems])

	const { id } = useParams();

	const { isPending: isPendingClientInformationById, data: companyInfo } = useGetClientInformationById(
		clientId,
		navigateToLogout
	);

	const { isPending, data } = useGetOffCyclePayrollTableData(
		clientId,
		selectedPayPeriodId,
		paymentType,
		selectedLabel,
		// payPeriodEndDate,
		queryParamsOffCyclePayrollData,
		navigateToLogout
	);
	const offCyclePayrollTableData: any | null = data;

	const {
		isPending: isPendingGetEmployeeDDLByStatus,
		data: edrEarningsAndTimeFormatData,
	} = useGetEDREarningsAndTimeFormatData(clientId, taxYear);


	const { isPending: isPendingCalculatedOffCyclePayrollTableData, data: calculatedOffCyclePayrollTableData } = useGetCalculatedOffCyclePayrollTableData(
		clientId,
		selectedPayPeriodId,
		selectedLabel,
		paymentType,
		// payPeriodStarDate,
		// payPeriodEndDate,
		queryParamsCalculatedOffCyclePayrollData,
		navigateToLogout
	);

	const {
		isPending: isPendingOffCyclePayrollPeriodsDDL,
		data: offCyclePayrollPeriodsDDL,
	} = useGetOffCyclePayrollPeriodsDDL(clientId, selectedPayPeriodId, taxYear);

	const {
		isPending: isPendingLabelsDDL,
		data: labelsDDL,
	} = useGetLabelsDDL(clientId, selectedPayPeriodId, taxYear, paymentType);


	const labelsDDLItems = useMemo(() => {
		if (labelsDDL && Array.isArray(labelsDDL)) {
			let ddl: any[] = sortDDLByLabel(labelsDDL).map((resourceItem: any) => ({
				id: resourceItem.value,
				label: resourceItem.label,
				value: resourceItem.value,
			}));
			ddl.unshift({
				label: "Create New",
				value: "create-new",
			});
			return ddl;
		} else if (labelsDDL) {
			return [
				{
					label: "Create New",
					value: "create-new",
				},
			];
		}
	}, [labelsDDL]);



	useEffect(() => {
		if (labelFieldValue && labelsDDL && labelsDDL.length && labelFieldDDLValue === 'create-new') {
			const selected = labelsDDL.find((x: any) => x.label === labelFieldValue)
			if (selected) {
				formMethods.setValue('labelDDL', selected.value)
				formMethods.setValue('label', selected.label)
				setSelectedLabel(selected.label)
			}
		} else if (labelFieldValue && labelsDDL && labelFieldDDLValue !== 'create-new') {
			const selected = labelsDDL.find((x: any) => x.value === labelFieldDDLValue)
			if (selected) {
				formMethods.setValue('labelDDL', selected.value)
				formMethods.setValue('label', selected.label)
				setSelectedLabel(selected.label)
			}
		}

	}, [labelsDDL])

	const onLabelSelectionChangeHandler = (selectedItem: any) => {
		let labelId = selectedItem.value
		if (labelId === 'create-new') {
			setSelectedLabel(null)
			// setSelectedPayPeriodId(null)
			setPayPeriodEndDate(null)
			// formMethods.setValue('payFrequencyDDLItems', undefined)
			formMethods.setValue('label', null)
			formMethods.setValue('payPeriodEndDate', null)
			// let path = `/payroll/off-cycle`
			// navigate(path)
		} else {
			formMethods.setValue('label', selectedItem.label)
			setSelectedLabel(selectedItem.label)

			let date = new Date(selectedItem.value)
			formMethods.setValue('payPeriodEndDate', date)
			setPayPeriodEndDate(selectedItem.value)
		}
	};
	const onLabelChangeHandler = (e: any) => {
		// let value = e.target.value;

		// setSelectedLabel(value)
	};

	const onPaymentTypeChangeHandler = (selectedItem: any) => {
		let type = selectedItem.value
		setPaymentType(type)
		formMethods.setValue('label', null)
		formMethods.setValue('labelDDL', 'create-new')
		formMethods.setValue('payPeriodEndDate', null)
	};

	const {
		isPending: isPendingVocationalEarningsList,
		data: vocationalEarningsList,
	} = useGetVocationalEarningsList(clientId);

	// get call employee list assign/unassignn
	const {
		isLoading: isLoadingAssignedEmployees,
		data: assignedAddEmployeeResponsePayload,
		refetch: refetchAddEmployeePanels,
	} = useGetOffCyclePayrollAddEmployeePanels(clientId, taxYear, selectedPayPeriodId, payPeriodEndDate, paymentType, labelFieldValue);
	let assignedAddEmployeeResponseData: any = assignedAddEmployeeResponsePayload;


	const onClickAddEmployeesHandler = (value: any) => {
		const labelFieldValue = formMethods.watch("label");

		if (!payPeriodEndDate) {
			setSnackbarData({
				open: true,
				message: `Please select date!`,
				severity: "error",
			});
		} else if (!labelFieldValue || labelFieldValue === "") {
			setSnackbarData({
				open: true,
				message: `Please add label!`,
				severity: "error",
			});
		} else {
			setAddEmployee(true);
			refetchAddEmployeePanels();
		}
	}
	const onCloseAddEmployeeHandler = () => {
		setAddEmployee(false);
		queryClient.invalidateQueries({
			queryKey: [LABALS_DDL_LIST_QUERY_KEY]
		})
		queryClient.invalidateQueries({
			queryKey: [PAYROLL_LIST_QUERY_KEY, clientId, selectedPayPeriodId, paymentType, selectedLabel, queryParamsOffCyclePayrollData]
		});
		// setIsApiCalls(false);
	};

	const moveEmployeeFirstPanelSelectionToolbar = useCallback(
		(selectedItems: any) => {

			setMoveEmployeeFirstPanelItems(selectedItems);
			return null;
		},
		[]
	);
	const moveEmployeeSecondPanelSelectionToolbar = useCallback(
		(selectedItems: any) => {

			setMoveEmployeeSecondPanelItems(selectedItems);
			return null;
		},
		[]
	);

	const [isLoadingAddEmployee, setIsLoadingAddEmployee] = useState(false)
	const [isLoadingRemoveEmployee, setIsLoadingRemoveEmployee] = useState(false)
	const onMoveAssignEmployeeClicked = () => {

		(async () => {
			try {
				setIsLoading(true);
				setIsLoadingAddEmployee(true);
				let selectedEmployeesIds = moveEmployeeFirstPanelItems.map((item: any) => item.employeeId);
				let payload = {
					clientId: clientId,
					employeeIds: selectedEmployeesIds,
					payPeriodEndDate: payPeriodEndDate,
					payrollSheduleId: selectedPayPeriodId,
					paymentType: paymentType,
					label: labelFieldValue
				}
				let requestPayload = payload;


				const responce: any = await OffCyclePayrollService.assignEmployees(requestPayload);
				if (responce.status === 201) {
					setSnackbarData({
						open: true,
						message: responce.data.message ? responce.data.message : `Employee has been added successfully!`,
						severity: "success",
					});
					refetchAddEmployeePanels();
					setMoveEmployeeFirstPanelItems([]);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [PAYROLL_LIST_QUERY_KEY, clientId,
								selectedPayPeriodId,
								paymentType,
								selectedLabel,
								// payPeriodStarDate,
								// payPeriodEndDate,
								queryParamsOffCyclePayrollData,],
						}),
						queryClient.invalidateQueries({
							queryKey: [CALCULATED_PAYROLL_LIST_QUERY_KEY, clientId,
								selectedPayPeriodId,
								selectedLabel,
								paymentType,
								// payPeriodStarDate,
								// payPeriodEndDate,
								queryParamsCalculatedOffCyclePayrollData,],
						}),
					]);
					// return queryClient.invalidateQueries({ queryKey: [ASSIGN_AND_UNASSIGNED_EMPLOYEE_DATA_QUERY_KEY, clientId, selectedPayPeriodId, payPeriodEndDate] });
				} else if (responce.status === 400) {
					setSnackbarData({
						open: true,
						message: responce.data.message ? responce.data.message : `Something went wrong!`,
						severity: "error",
					});
				} else {
					setSnackbarData({
						open: true,
						message: responce.message ? responce.message : `Something went wrong!`,
						severity: "error",
					});
				}
			} catch (error: any) {
				setSnackbarData({
					open: true,
					message: "Somthing went wrong!",
					severity: "error",
				});
				setIsLoading(false);
				setIsLoadingAddEmployee(false);
			} finally {
				setIsLoading(false);
				setIsLoadingAddEmployee(false);
			}
		})();
	};
	const onMoveUnAssignedEmployeeClicked = () => {

		(async () => {
			try {
				setIsLoading(true);
				setIsLoadingRemoveEmployee(true);
				let selectedEmployeesIds = moveEmployeeSecondPanelItems.map((item: any) => item.employeeId);
				let payload = {
					clientId: clientId,
					employeeIds: selectedEmployeesIds,
					payPeriodEndDate: payPeriodEndDate,
					payrollSheduleId: selectedPayPeriodId,
					paymentType: paymentType,
					label: labelFieldValue
				}
				let requestPayload = payload;


				const responce: any = await OffCyclePayrollService.unAssignEmployees(requestPayload);
				if (responce.status === 201) {
					setSnackbarData({
						open: true,
						message: responce.data.message ? responce.data.message : `Employee has been removed successfully!`,
						severity: "success",
					});
					refetchAddEmployeePanels();
					setMoveEmployeeSecondPanelItems([]);
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [PAYROLL_LIST_QUERY_KEY, clientId,
								selectedPayPeriodId,
								paymentType,
								selectedLabel,
								// payPeriodStarDate,
								// payPeriodEndDate,
								queryParamsOffCyclePayrollData,],
						}),
						queryClient.invalidateQueries({
							queryKey: [CALCULATED_PAYROLL_LIST_QUERY_KEY, clientId,
								selectedPayPeriodId,
								selectedLabel,
								paymentType,
								// payPeriodStarDate,
								// payPeriodEndDate,
								queryParamsCalculatedOffCyclePayrollData,],
						}),
					]);
					// return queryClient.invalidateQueries({ queryKey: [ASSIGN_AND_UNASSIGNED_EMPLOYEE_DATA_QUERY_KEY] });
				} else if (responce.status === 400) {
					setSnackbarData({
						open: true,
						message: responce.data.message ? responce.data.message : `Something went wrong!`,
						severity: "error",
					});
				} else {
					setSnackbarData({
						open: true,
						message: responce.message ? responce.message : `Something went wrong!`,
						severity: "error",
					});
				}
			} catch (error: any) {
				setSnackbarData({
					open: true,
					message: "Somthing went wrong!",
					severity: "error",
				});
				setIsLoading(false);
				setIsLoadingRemoveEmployee(false);
			} finally {
				setIsLoadingRemoveEmployee(false);
				setIsLoading(false);
			}
		})();
	};

	// useEffect(() => {
	// 	if (offCyclePayrollPeriodsDDL && offCyclePayrollPeriodsDDL.length > 0) {
	// 		let lastItem = offCyclePayrollPeriodsDDL.at(-1)
	// 		// if(lastItem.process){

	// 		// }
	// 		const selectedOffCyclePayrollPeriodIndex = offCyclePayrollPeriodsDDL.findIndex((item: any) => item.value === lastItem.value);

	// 		formMethods.setValue('offCyclePayrollPeriodsDDL', lastItem.endDate)
	// 		formMethods.setValue('payFrequencyDDLItems', lastItem.payScheduleId)
	// 		setSelectedPayPeriodIndex(selectedOffCyclePayrollPeriodIndex)
	// 		setPayPeriodStarDate(lastItem.startDate)
	// 		setPayPeriodEndDate(lastItem.endDate)
	// 	}
	// }, [offCyclePayrollPeriodsDDL])

	const { data: departmentsDDL, isPending: isPendingDepartmentDDL } =
		useGetDepartmentsDDL(clientId);


	const departmentsDDLItems = useMemo(() => {
		if (departmentsDDL && Array.isArray(departmentsDDL)) {
			let resources: any[] = sortDDLByLabel(departmentsDDL).map((resourceItem: any) => ({
				id: resourceItem.value,
				label: resourceItem.label,
				value: resourceItem.value,
			}));
			resources.unshift({
				label: "Department: ALL",
				value: "all",
			});
			return resources;
		} else if (departmentsDDL) {
			return [
				{
					label: "Department: ALL",
					value: "all",
				},
			];
		}
	}, [departmentsDDL]);



	const { isPending: isSubmitting, mutate: submitOffCyclePayroll } = useMutation({
		mutationFn: OffCyclePayrollService.create,

		onSuccess: (res: IOffCyclePayroll | IServerError | IResponse | any) => {


			if (res && res.status === 201) {
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				return Promise.all([
					queryClient.invalidateQueries({
						queryKey: [LABALS_DDL_LIST_QUERY_KEY]
					}),
					queryClient.invalidateQueries({
						queryKey: [PAYROLL_PERIODS_DDL_LIST_QUERY_KEY, clientId, selectedPayPeriodId, taxYear, paymentType],
					}),
					queryClient.invalidateQueries({
						queryKey: [PAYROLL_LIST_QUERY_KEY, clientId,
							selectedPayPeriodId,
							paymentType,
							selectedLabel,
							// payPeriodStarDate,
							// payPeriodEndDate,
							queryParamsOffCyclePayrollData,],
					}),
					queryClient.invalidateQueries({
						queryKey: [CALCULATED_PAYROLL_LIST_QUERY_KEY, clientId,
							selectedPayPeriodId,
							selectedLabel,
							paymentType,
							// payPeriodStarDate,
							// payPeriodEndDate,
							queryParamsCalculatedOffCyclePayrollData,],
					}),
				]);
			} else {
				setSnackbarData({
					open: true,
					message:
						res && res.message && res.message
							? res.message
							: "Something went wrong.",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const { isPending: isCalculatingOffCyclePayroll, mutate: calculateOffCyclePayroll } = useMutation({
		mutationFn: OffCyclePayrollService.calculate,

		onSuccess: (res: IOffCyclePayroll | IServerError | IResponse | any) => {


			if (res && res.status === 201) {
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				return Promise.all([
					queryClient.invalidateQueries({
						queryKey: [LABALS_DDL_LIST_QUERY_KEY]
					}),
					queryClient.invalidateQueries({
						queryKey: [PAYROLL_PERIODS_DDL_LIST_QUERY_KEY, clientId, selectedPayPeriodId, taxYear, paymentType],
					}),
					queryClient.invalidateQueries({
						queryKey: [PAYROLL_LIST_QUERY_KEY, clientId,
							selectedPayPeriodId,
							paymentType,
							selectedLabel,
							// payPeriodStarDate,
							// payPeriodEndDate,
							queryParamsOffCyclePayrollData,],
					}),
					queryClient.invalidateQueries({
						queryKey: [CALCULATED_PAYROLL_LIST_QUERY_KEY, clientId,
							selectedPayPeriodId,
							selectedLabel,
							paymentType,
							// payPeriodStarDate,
							// payPeriodEndDate,
							queryParamsCalculatedOffCyclePayrollData,],
					}),
				]);
			} else {
				setSnackbarData({
					open: true,
					message:
						res && res.message && res.message
							? res.message
							: "Something went wrong.",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const { isPending: isInsertingEmployeeOffCyclePayrollData, mutate: insertEmployeeOffCyclePayrollData } = useMutation({
		mutationFn: OffCyclePayrollService.insertEmployeeOffCyclePayrollData,

		onSuccess: (res: IOffCyclePayroll | IServerError | IResponse | any) => {


			if (res && res.status === 201) {
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				return Promise.all([
					queryClient.invalidateQueries({
						queryKey: [LABALS_DDL_LIST_QUERY_KEY]
					}),
					queryClient.invalidateQueries({
						queryKey: [PAYROLL_PERIODS_DDL_LIST_QUERY_KEY, clientId, selectedPayPeriodId, taxYear, paymentType],
					}),
					queryClient.invalidateQueries({
						queryKey: [PAYROLL_LIST_QUERY_KEY, clientId,
							selectedPayPeriodId,
							paymentType,
							selectedLabel,
							// payPeriodStarDate,
							// payPeriodEndDate,
							queryParamsOffCyclePayrollData,],
					}),
					queryClient.invalidateQueries({
						queryKey: [CALCULATED_PAYROLL_LIST_QUERY_KEY, clientId,
							selectedPayPeriodId,
							selectedLabel,
							paymentType,
							// payPeriodStarDate,
							// payPeriodEndDate,
							queryParamsCalculatedOffCyclePayrollData,],
					}),
				]);
			} else {
				setSnackbarData({
					open: true,
					message:
						res && res.message && res.message
							? res.message
							: "Something went wrong.",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const { isPending: isEditingCalculatdeOffCyclePayroll, mutate: editingCalculatdeOffCyclePayroll } = useMutation({
		mutationFn: OffCyclePayrollService.editingCalculatdeOffCyclePayroll,

		onSuccess: (res: IOffCyclePayroll | IServerError | IResponse | any) => {


			if (res && res.status === 200) {
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				return Promise.all([
					queryClient.invalidateQueries({
						queryKey: [LABALS_DDL_LIST_QUERY_KEY]
					}),
					queryClient.invalidateQueries({
						queryKey: [PAYROLL_PERIODS_DDL_LIST_QUERY_KEY, clientId, selectedPayPeriodId, taxYear, paymentType],
					}),
					queryClient.invalidateQueries({
						queryKey: [PAYROLL_LIST_QUERY_KEY, clientId,
							selectedPayPeriodId,
							paymentType,
							selectedLabel,
							// payPeriodStarDate,
							// payPeriodEndDate,
							queryParamsOffCyclePayrollData,],
					}),
					queryClient.invalidateQueries({
						queryKey: [CALCULATED_PAYROLL_LIST_QUERY_KEY, clientId,
							selectedPayPeriodId,
							selectedLabel,
							paymentType,
							// payPeriodStarDate,
							// payPeriodEndDate,
							queryParamsCalculatedOffCyclePayrollData,],
					}),
				]);
			} else {
				setSnackbarData({
					open: true,
					message:
						res && res.message && res.message
							? res.message
							: "Something went wrong.",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const { isPending: isSavingCalculatdeOffCyclePayroll, mutate: savingCalculatdeOffCyclePayroll } = useMutation({
		mutationFn: OffCyclePayrollService.savingCalculatdeOffCyclePayroll,

		onSuccess: (res: IOffCyclePayroll | IServerError | IResponse | any) => {


			if (res && res.status === 200) {
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				return Promise.all([
					queryClient.invalidateQueries({
						queryKey: [LABALS_DDL_LIST_QUERY_KEY]
					}),
					queryClient.invalidateQueries({
						queryKey: [PAYROLL_PERIODS_DDL_LIST_QUERY_KEY, clientId, selectedPayPeriodId, taxYear, paymentType],
					}),
					queryClient.invalidateQueries({
						queryKey: [PAYROLL_LIST_QUERY_KEY, clientId,
							selectedPayPeriodId,
							paymentType,
							selectedLabel,
							// payPeriodStarDate,
							// payPeriodEndDate,
							queryParamsOffCyclePayrollData,],
					}),
					queryClient.invalidateQueries({
						queryKey: [CALCULATED_PAYROLL_LIST_QUERY_KEY, clientId,
							selectedPayPeriodId,
							selectedLabel,
							paymentType,
							// payPeriodStarDate,
							// payPeriodEndDate,
							queryParamsCalculatedOffCyclePayrollData,],
					}),
				]);
			} else {
				setSnackbarData({
					open: true,
					message:
						res && res.message && res.message
							? res.message
							: "Something went wrong.",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});
	const { isPending: isOverwriteCalculatdeOffCyclePayroll, mutate: overwriteCalculatdeOffCyclePayroll } = useMutation({
		mutationFn: OffCyclePayrollService.overwriteCalculatdeOffCyclePayroll,

		onSuccess: (res: IOffCyclePayroll | IServerError | IResponse | any) => {


			if (res && res.status === 200) {
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				return Promise.all([
					queryClient.invalidateQueries({
						queryKey: [LABALS_DDL_LIST_QUERY_KEY]
					}),
					queryClient.invalidateQueries({
						queryKey: [PAYROLL_PERIODS_DDL_LIST_QUERY_KEY, clientId, selectedPayPeriodId, paymentType, taxYear],
					}),
					queryClient.invalidateQueries({
						queryKey: [PAYROLL_LIST_QUERY_KEY, clientId,
							selectedPayPeriodId,
							paymentType,
							selectedLabel,
							// payPeriodStarDate,
							// payPeriodEndDate,
							queryParamsOffCyclePayrollData,],
					}),
					queryClient.invalidateQueries({
						queryKey: [CALCULATED_PAYROLL_LIST_QUERY_KEY, clientId,
							selectedPayPeriodId,
							selectedLabel,
							paymentType,
							// payPeriodStarDate,
							// payPeriodEndDate,
							queryParamsCalculatedOffCyclePayrollData,],
					}),
				]);
			} else {
				setSnackbarData({
					open: true,
					message:
						res && res.message && res.message
							? res.message
							: "Something went wrong.",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	const [openEmployeeOffCyclePayrollDataDialog, setDialogEmployeeOffCyclePayrollDataOpen] = useState(false);
	const [openEmployeeOffCyclePayrollCalculatedDataDialog, setDialogEmployeeOffCyclePayrollCalculatedDataOpen] = useState(false);
	const [offCyclePayrollDataGridSelectedRows, setOffCyclePayrollDataGridSelectedRows] = useState([]);
	const [calculatedOffCyclePayrollDataGridSelectedRows, setCalculatedOffCyclePayrollDataGridSelectedRows] = useState([]);
	const [selectedIds, setSelectedIds] = useState([]);
	const [offCyclePayrollSetupUpdatedItems, setOffCyclePayrollUpdatedItems] =
		useState<any>(undefined);

	// for employee offCyclePayroll data delete row
	const [singleEmployeeOffCyclePayrollDataDelete, setEmployeeOffCyclePayrollDataDelete] = useState<boolean>(false);
	// const [offCyclePayrollRowData, setOffCyclePayrollRowData] = useState<any>(0);

	const [submitAddRemoveColumnsHandler, setSubmitAddRemoveColumnsHandler] =
		useState(undefined);
	const [onColumnReorder, setOnColumnReorder] = useState(undefined);

	const onRequestParamsChangeOffCyclePayrollData = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "name",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParamsOffCyclePayrollData(dispatchParams);
	}, []);
	const onRequestParamsChangeCalculatedOffCyclePayrollData = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "name",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParamsCalculatedOffCyclePayrollData(dispatchParams);
	}, []);

	const { isPending: isDeletingEmployeeOffCyclePayrollData, mutate: deleteEmployeeOffCyclePayrollDataById } =
		useMutation({
			mutationFn: OffCyclePayrollService.delEmployeeOffCyclePayrollData,

			onSuccess: (res: string | IServerError | IResponse) => {
				if (typeof res === "string") {
					// remove the cache of the OffCyclePayroll fields since we just added a new field.
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
				} else {
					setSnackbarData({
						open: true,
						message: "Something went wrong, try again later!",
						severity: "error",
					});
				}
				return queryClient.invalidateQueries({
					queryKey: [PAYROLL_LIST_QUERY_KEY],
				});
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const deleteEmployeeOffCyclePayrollDataField = () => {
		if (singleEmployeeOffCyclePayrollDataDelete) {
			setEmployeeOffCyclePayrollDataDelete(false);
			if (offCyclePayrollTableData && offCyclePayrollTableData.rowSelection) {
				if (offCyclePayrollDataGridSelectedRows.length > 0) {
					const empIds = offCyclePayrollDataGridSelectedRows.map((x: any) => x.employeeId)

					let delEmployeeOffCyclePayrollDataPayload = {
						data: {
							clientId: clientId,
							payPeriodEndDate: payPeriodEndDate,
							offCyclePayrollSheduleId: selectedPayPeriodId,
							paymentType: paymentType,
							employeeIds: empIds
						},
						navigateToLogout: navigateToLogout,
					};
					deleteEmployeeOffCyclePayrollDataById(delEmployeeOffCyclePayrollDataPayload);
					setDialogEmployeeOffCyclePayrollDataOpen(false);
				} else {
					setSnackbarData({
						open: true,
						message: "Please select at least one employee!",
						severity: "error"
					})
				}
			} else {
				const empIds = offCyclePayrollSetupTableData.map((x: any) => x.employeeId)

				let delEmployeeOffCyclePayrollDataPayload = {
					data: {
						clientId: clientId,
						payPeriodEndDate: payPeriodEndDate,
						offCyclePayrollSheduleId: selectedPayPeriodId,
						paymentType: paymentType,
						employeeIds: empIds
					},
					navigateToLogout: navigateToLogout,
				};
				deleteEmployeeOffCyclePayrollDataById(delEmployeeOffCyclePayrollDataPayload);
				setDialogEmployeeOffCyclePayrollDataOpen(false);
			}
		}
	};

	// const onRowDeleteClicked = useCallback((params: any) => {
	// 	setDialogEmployeeOffCyclePayrollDataOpen(true);
	// 	setEmployeeOffCyclePayrollDataDelete(true);
	// 	setOffCyclePayrollRowData(params);
	// }, []);

	const onDeleteEmployeeOffCyclePayrollDataClicked = () => {
		setDialogEmployeeOffCyclePayrollDataOpen(true);
		setEmployeeOffCyclePayrollDataDelete(true);
		// if (selectedDataRecord) {
		// 	setAccountantId(selectedDataRecord.id);
		// }
	};

	const onRowEditClicked = useCallback((params: any) => {
		// alert(`Edit row with ID: ${params.row.id} has been clicked!`);
		let path = `/payroll/off-cycle/${params.id}`;
		navigate(path);
	}, []);

	const onCloseEmployeeOffCyclePayrollDataDeleteHandler = () => {
		setDialogEmployeeOffCyclePayrollDataOpen(false);
	};

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const selectionToolbar = useCallback((selectedItems: any) => {
		let selectedItemsIds = selectedItems && selectedItems.map((item: any) => item.id);


		setOffCyclePayrollDataGridSelectedRows(selectedItems);

		// if (selectedItems.length) {
		// 	return (
		// 		<></>
		// 	);
		// }
		return (
			<></>
		);
	}, []);
	const CalculatedOffCyclePayrollDataGridSelectionToolbar = useCallback((selectedItems: any) => {
		let selectedItemsIds = selectedItems && selectedItems.map((item: any) => item.id);
		setCalculatedOffCyclePayrollDataGridSelectedRows(selectedItems);
		return (
			<></>
		);
	}, []);
	const upadtedOffCyclePayrollItems = useMemo(() => {
		if (offCyclePayrollTableData && offCyclePayrollTableData.items) {
			return offCyclePayrollTableData.items;
		}
	}, [offCyclePayrollTableData]);

	const upadtedCalculatedOffCyclePayrollItems = useMemo(() => {
		if (calculatedOffCyclePayrollTableData && calculatedOffCyclePayrollTableData.items) {
			return calculatedOffCyclePayrollTableData.items;
		}
	}, [calculatedOffCyclePayrollTableData]);



	// const expandedLabels = ["OffCyclePayroll"];
	// const expandedOffCyclePayrollOrSetupItem = "OffCyclePayroll"; // Special case for "List" under "OffCyclePayroll"
	// const enhanceData = (data: any[], parentLabel?: string): any[] => {
	// 	return data.map((item) => {
	// 		let isExpanded = expandedLabels.includes(item.label);
	// 		if (
	// 			parentLabel === "OffCyclePayroll" &&
	// 			item.label === expandedOffCyclePayrollOrSetupItem
	// 		) {
	// 			isExpanded = true;
	// 		}
	// 		const enhancedItem = {
	// 			...item,
	// 			expanded: isExpanded,
	// 			items: item.items ? enhanceData(item.items, item.label) : undefined,
	// 		};
	// 		return enhancedItem;
	// 	});
	// };
	const expandedLabels = ["Payroll"];
	const expandedOffCyclePayrollOrSetupItem = "Off-Cycle";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Payroll" &&
				item.label === expandedOffCyclePayrollOrSetupItem
			) {
				isExpanded = true;
			}

			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedOffCyclePayrollOrSetupItem && "/payroll/off-cycle",
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: PAYROLL_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);


		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
	}, [drawerMenuOptions]);


	const onSubmit = (values: any) => {

	};

	useEffect(() => {
		if (id && !selectedPayPeriodId) {
			setSelectedPayPeriodId(id)
			setShowAddRemoveEmployees(true)
			formMethods.setValue('payFrequencyDDLItems', id)
		}
	}, [id])
	const onFrequencyChangeHandler = async (selectedItem: any) => {
		setSelectedPayPeriodId(selectedItem.value)
		setShowAddRemoveEmployees(true)
		let path = `/payroll/off-cycle/${selectedItem.value}`
		navigate(path)
	};
	const onPayPeriodDateSelectionChangeHandler = (e: any) => {
		let date = formatDate(e.value)

		setPayPeriodEndDate(date)
	}
	// const onOffCyclePayrollPeriodsDDLChangeHandler = async (selectedItem: any) => {
	// 	const selectedoffCyclePayrollPeriodValue = formMethods.watch("offCyclePayrollPeriodsDDL");

	// 	if (selectedoffCyclePayrollPeriodValue && offCyclePayrollPeriodsDDL) {
	// 		const selectedOffCyclePayrollPeriod = offCyclePayrollPeriodsDDL && offCyclePayrollPeriodsDDL.find((x: any) => x.endDate === selectedoffCyclePayrollPeriodValue)
	// 		const selectedOffCyclePayrollPeriodIndex = offCyclePayrollPeriodsDDL.findIndex((item: any) => item.value === selectedOffCyclePayrollPeriod.value);

	// 		setSelectedPayPeriodIndex(selectedOffCyclePayrollPeriodIndex)
	// 		setPayPeriodStarDate(selectedOffCyclePayrollPeriod.startDate)
	// 		setPayPeriodEndDate(selectedOffCyclePayrollPeriod.endDate)
	// 	}
	// };

	const buildCustomEarningsArray = (
		item: any,
		edrList: { label: string; value: string }[]
	) => {
		return edrList.map(edr => {
			const key = `customAmounts.${edr.label}`;

			return {
				id: edr.value,
				label: edr.label,
				value: Object.prototype.hasOwnProperty.call(item, key)
					? item[key]
					: item.customAmounts[edr.label]
			};
		});
	};

	const onSubmitButtonClickedHandler = () => {
		const labelFieldValue = formMethods.watch("label");
		// const payPeriodEndDateFieldValue = formMethods.watch("payPeriodEndDate");
		if (offCyclePayrollTableData && offCyclePayrollTableData.rowSelection) {
			if (offCyclePayrollDataGridSelectedRows.length > 0) {
				const updatePayloadData =
					offCyclePayrollDataGridSelectedRows &&
					offCyclePayrollDataGridSelectedRows.map((item: any) => ({
						...item,
						clientId: clientId,
						payPeriodEndDate: payPeriodEndDate,
						offCyclePayrollSheduleId: selectedPayPeriodId,
						paymentType: paymentType,
						vacationPayAccured: item.vacationPayAccured ? item.vacationPayAccured : item.vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined ?
							item.vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined : undefined,
						vacationPayAccuredCalculateWhenVacationPayAccuredIsUndefined: undefined,
						customEarnings: paymentType === 200 ? buildCustomEarningsArray(item, edrEarningsAndTimeFormatData.earnings) : undefined,
						customDeductions: paymentType === 200 ? buildCustomEarningsArray(item, edrEarningsAndTimeFormatData.deductions) : undefined,
						customReimbursements: paymentType === 200 ? buildCustomEarningsArray(item, edrEarningsAndTimeFormatData.reimbursements) : undefined,
						label: labelFieldValue,
					}));



				if (!payPeriodEndDate) {
					setSnackbarData({
						open: true,
						message: "Please select pay period end date!",
						severity: "error"
					})
				} else if (!labelFieldValue || labelFieldValue === "") {
					setSnackbarData({
						open: true,
						message: "Label is required",
						severity: "error"
					})
				} else {
					if (paymentType !== 200) {
						const isValid = updatePayloadData.every((item: any) => {
							const hasGross = item.grossIncome !== null && item.grossIncome !== 0;
							return hasGross;
						});
						if (isValid) {
							submitOffCyclePayroll({ payrollData: updatePayloadData })
							queryClient.invalidateQueries({
								queryKey: [LABALS_DDL_LIST_QUERY_KEY]
							});
						} else {
							setSnackbarData({
								open: true,
								message: "Gross is required",
								severity: "error"
							})
						}
					} else {
						submitOffCyclePayroll({ payrollData: updatePayloadData })
						queryClient.invalidateQueries({
							queryKey: [LABALS_DDL_LIST_QUERY_KEY]
						});
					}
				}
			} else {
				setSnackbarData({
					open: true,
					message: "Please select at least one employee!",
					severity: "error"
				})
			}
		} else {
			const updatePayloadData =
				offCyclePayrollSetupTableData &&
				offCyclePayrollSetupTableData.map((item: any) => ({
					...item,
					clientId: clientId,
					payPeriodEndDate: payPeriodEndDate,
					offCyclePayrollSheduleId: selectedPayPeriodId,
					paymentType: paymentType,
					customEarnings: paymentType === 200 ? buildCustomEarningsArray(item, edrEarningsAndTimeFormatData.earnings) : undefined,
					customDeductions: paymentType === 200 ? buildCustomEarningsArray(item, edrEarningsAndTimeFormatData.deductions) : undefined,
					customReimbursements: paymentType === 200 ? buildCustomEarningsArray(item, edrEarningsAndTimeFormatData.reimbursements) : undefined,
					label: labelFieldValue,
				}));
			if (!payPeriodEndDate) {
				setSnackbarData({
					open: true,
					message: "Please select pay period end date!",
					severity: "error"
				})
			} else if (!labelFieldValue || labelFieldValue === "") {
				setSnackbarData({
					open: true,
					message: "Label is required",
					severity: "error"
				})
			} else {
				if (paymentType !== 200) {
					const isValid = updatePayloadData.every((item: any) => {
						const hasGross = item.grossIncome !== null && item.grossIncome !== 0;
						return hasGross;
					});
					if (isValid) {
						submitOffCyclePayroll({ payrollData: updatePayloadData })
						queryClient.invalidateQueries({
							queryKey: [LABALS_DDL_LIST_QUERY_KEY]
						});
					} else {
						setSnackbarData({
							open: true,
							message: "Gross is required",
							severity: "error"
						})
					}
				} else {
					submitOffCyclePayroll({ payrollData: updatePayloadData })
					queryClient.invalidateQueries({
						queryKey: [LABALS_DDL_LIST_QUERY_KEY]
					});
				}
			}
		}
	};
	const onCalculateOffCyclePayroll = async (requestPayload: any, labelFieldValue: any, payPeriodEndDateFieldValue: any, paymentType: number) => {
		if (paymentType !== 200) {
			const isValid = requestPayload.every((item: any) => {
				const hasGross = item.grossIncome !== null && item.grossIncome !== 0;
				return hasGross;
			});
			if (isValid) {
				(async () => {
					try {
						setIsLoading(true)
						const response = await OffCyclePayrollService.create({ payrollData: requestPayload });
						if (response && response.status === 201) {
							const empIds = offCyclePayrollDataGridSelectedRows.map((x: any) => x.employeeId)
							let calculateOffCyclePayrollDataPayload = {
								data: {
									clientId: clientId,
									payPeriodEndDate: formatDate(payPeriodEndDateFieldValue),
									payrollSheduleId: selectedPayPeriodId,
									paymentType: paymentType,
									employeeIds: empIds
								},
								navigateToLogout: navigateToLogout,
							};
							calculateOffCyclePayroll(calculateOffCyclePayrollDataPayload);
							queryClient.invalidateQueries({
								queryKey: [LABALS_DDL_LIST_QUERY_KEY]
							});
						} else {
							setSnackbarData({
								open: true,
								message:
									response && response.message && response.message
										? response.message
										: "Something went wrong.",
								severity: "error",
							});
						}

					} catch { } finally { setIsLoading(false) }
				})();
			} else {
				setSnackbarData({
					open: true,
					message: "Gross is required",
					severity: "error"
				})
			}
		} else {

			(async () => {
				try {
					setIsLoading(true)
					const response = await OffCyclePayrollService.create({ payrollData: requestPayload });
					if (response && response.status === 201) {
						const empIds = offCyclePayrollDataGridSelectedRows.map((x: any) => x.employeeId)
						let calculateOffCyclePayrollDataPayload = {
							data: {
								clientId: clientId,
								payPeriodEndDate: formatDate(payPeriodEndDateFieldValue),
								payrollSheduleId: selectedPayPeriodId,
								paymentType: paymentType,
								employeeIds: empIds
							},
							navigateToLogout: navigateToLogout,
						};
						calculateOffCyclePayroll(calculateOffCyclePayrollDataPayload);
						queryClient.invalidateQueries({
							queryKey: [LABALS_DDL_LIST_QUERY_KEY]
						});
					} else {
						setSnackbarData({
							open: true,
							message:
								response && response.message && response.message
									? response.message
									: "Something went wrong.",
							severity: "error",
						});
					}

				} catch { } finally { setIsLoading(false) }
			})();
		}
	};

	const onCalculateOffCyclePayrollClicked = async () => {
		const labelFieldValue = formMethods.watch("label");
		// const payPeriodEndDateFieldValue = formMethods.watch("payPeriodEndDate");
		if (offCyclePayrollTableData && offCyclePayrollTableData.rowSelection) {
			if (offCyclePayrollDataGridSelectedRows.length > 0) {
				const updatePayloadData =
					offCyclePayrollDataGridSelectedRows &&
					offCyclePayrollDataGridSelectedRows.map((item: any) => ({
						...item,
						clientId: clientId,
						payPeriodEndDate: payPeriodEndDate,
						offCyclePayrollSheduleId: selectedPayPeriodId,
						paymentType: paymentType,
						customEarnings: paymentType === 200 ? buildCustomEarningsArray(item, edrEarningsAndTimeFormatData.earnings) : undefined,
						customDeductions: paymentType === 200 ? buildCustomEarningsArray(item, edrEarningsAndTimeFormatData.deductions) : undefined,
						customReimbursements: paymentType === 200 ? buildCustomEarningsArray(item, edrEarningsAndTimeFormatData.reimbursements) : undefined,
						label: labelFieldValue,
					}));
				if (!payPeriodEndDate) {
					setSnackbarData({
						open: true,
						message: "Please select pay period end date!",
						severity: "error"
					})
				} else if (!labelFieldValue || labelFieldValue === "") {
					setSnackbarData({
						open: true,
						message: "Label is required",
						severity: "error"
					})
				} else {
					onCalculateOffCyclePayroll(updatePayloadData, labelFieldValue, payPeriodEndDate, paymentType)
				}
			} else {
				setSnackbarData({
					open: true,
					message: "Please select at least one employee!",
					severity: "error"
				})
			}
		} else {
			const updatePayloadData =
				offCyclePayrollSetupTableData &&
				offCyclePayrollSetupTableData.map((item: any) => ({
					...item,
					clientId: clientId,
					payPeriodEndDate: payPeriodEndDate,
					offCyclePayrollSheduleId: selectedPayPeriodId,
					paymentType: paymentType,
					customEarnings: paymentType === 200 ? buildCustomEarningsArray(item, edrEarningsAndTimeFormatData.earnings) : undefined,
					customDeductions: paymentType === 200 ? buildCustomEarningsArray(item, edrEarningsAndTimeFormatData.deductions) : undefined,
					customReimbursements: paymentType === 200 ? buildCustomEarningsArray(item, edrEarningsAndTimeFormatData.reimbursements) : undefined,
					label: labelFieldValue,
				}));
			if (!payPeriodEndDate) {
				setSnackbarData({
					open: true,
					message: "Please select pay period end date!",
					severity: "error"
				})
			} else if (!labelFieldValue || labelFieldValue === "") {
				setSnackbarData({
					open: true,
					message: "Label is required",
					severity: "error"
				})
			} else {
				onCalculateOffCyclePayroll(updatePayloadData, labelFieldValue, payPeriodEndDate, paymentType)
			}
		}
	};
	const onInsertButtonClicked = (selectedItem: any) => {

		if (offCyclePayrollTableData && offCyclePayrollTableData.rowSelection) {
			if (offCyclePayrollDataGridSelectedRows.length > 0) {
				const empIds = offCyclePayrollDataGridSelectedRows.map((x: any) => x.employeeId)

				let insertEmployeeOffCyclePayrollDataPayload = {
					data: {
						clientId: clientId,
						payPeriodEndDate: payPeriodEndDate,
						offCyclePayrollSheduleId: selectedPayPeriodId,
						paymentType: paymentType,
						employeeIds: empIds,
						insertingType: selectedItem === "Insert Gross Hours" ? 100 :
							selectedItem === "Insert Gross" ? 200 :
								selectedItem === "Insert Hours" ? 300 :
									selectedItem === "Insert Previous" ? 400 :
										selectedItem === "Insert EDR" ? 500 : selectedItem
					},
					navigateToLogout: navigateToLogout,
				};
				insertEmployeeOffCyclePayrollData(insertEmployeeOffCyclePayrollDataPayload);
			} else {
				setSnackbarData({
					open: true,
					message: "Please select at least one employee!",
					severity: "error"
				})
			}
		} else {
			const empIds = offCyclePayrollSetupTableData.map((x: any) => x.employeeId)

			let insertEmployeeOffCyclePayrollDataPayload = {
				data: {
					clientId: clientId,
					payPeriodEndDate: payPeriodEndDate,
					offCyclePayrollSheduleId: selectedPayPeriodId,
					paymentType: paymentType,
					employeeIds: empIds,
					insertingType: selectedItem === "Insert Gross Hours" ? 100 :
						selectedItem === "Insert Gross" ? 200 :
							selectedItem === "Insert Hours" ? 300 :
								selectedItem === "Insert Previous" ? 400 :
									selectedItem === "Insert EDR" ? 500 : selectedItem
				},
				navigateToLogout: navigateToLogout,
			};
			insertEmployeeOffCyclePayrollData(insertEmployeeOffCyclePayrollDataPayload);
		}
	};





	// for calculated offCyclePayroll buttons
	const onEditCalculatedOffCyclePayrollButtonClicked = async () => {

		const selectedoffCyclePayrollFrequencyValue = formMethods.watch("payFrequencyDDLItems");
		const labelFieldValue = formMethods.watch("label");
		if (selectedoffCyclePayrollFrequencyValue && payFrequencyDDLItems) {
			const selectedOffCyclePayrollFrequency = payFrequencyDDLItems && payFrequencyDDLItems.find((x: any) => x.value === selectedoffCyclePayrollFrequencyValue)

			if (offCyclePayrollTableData && offCyclePayrollTableData.rowSelection) {
				if (calculatedOffCyclePayrollDataGridSelectedRows.length > 0) {
					const updatePayloadData =
						calculatedOffCyclePayrollDataGridSelectedRows &&
						calculatedOffCyclePayrollDataGridSelectedRows.map((item: any) => ({
							...item,
							clientId: clientId,
							payPeriod: selectedOffCyclePayrollFrequency.payPeriodCode,
							// payPeriodEndDate: payPeriodEndDate,
							PayrollSheduleId: selectedPayPeriodId,
							paymentType: paymentType,
							label: labelFieldValue
						}));

					editingCalculatdeOffCyclePayroll({
						clientId,
						data: { payrollData: updatePayloadData },
						navigateToLogout: navigateToLogout
					});
				} else {
					setSnackbarData({
						open: true,
						message: "Please select at least one employee!",
						severity: "error"
					})
				}
			} else {
				const updatePayloadData =
					calculatedOffCyclePayrollTableData &&
					calculatedOffCyclePayrollTableData.map((item: any) => ({
						...item,
						clientId: clientId,
						payPeriod: selectedOffCyclePayrollFrequency.payPeriodCode,
						payPeriodEndDate: payPeriodEndDate,
						PayrollSheduleId: selectedPayPeriodId,
						paymentType: paymentType,
						label: labelFieldValue
					}));
				editingCalculatdeOffCyclePayroll({
					clientId,
					data: { payrollData: updatePayloadData },
					navigateToLogout: navigateToLogout
				});
			}
		}
	};
	const onPrintCheckOrStubClaculatedOOffCyclePayrollButtonClickedHandler = async (selectedItem: any) => {
		// alert(selectedItem)
		const empIds = calculatedOffCyclePayrollDataGridSelectedRows.map((x: any) => x.employeeId)
		if (selectedItem === 'Print Stub Only') {
			if (calculatedOffCyclePayrollDataGridSelectedRows && calculatedOffCyclePayrollDataGridSelectedRows.length > 0) {
				(async () => {
					let payload = {
						clientId: clientId,
						empIds
					}
					try {
						setIsLoading(true)
						const response: any = await OffCyclePayrollService.createStubOffCyclePayrollPdfPrint(
							payload
						);
						if (response.status === 400) {
							setSnackbarData({
								open: true,
								message: response.data.message
									? response.data.message
									: "Something went wrong.",
								severity: "error",
							});
						} else {
							const filename = `StubPrint.pdf`;
							savePdfAsFile(response, filename);
						}
					} catch { } finally { setIsLoading(false) }
				})();
			} else {
				setSnackbarData({
					open: true,
					message: "Please select ateast one employee",
					severity: "error",
				})

			}
		}
	};

	// const onPrintCheckOrStubClaculatedOOffCyclePayrollButtonClickedHandler = async (): Promise<void> => {
	// 	const maskedStatus: any = sessionStorage.getItem("maskEnabled");
	// 	if (maskedStatus === "true") {
	// 		setSnackbarData({
	// 			open: true,
	// 			message: "Please unmask your data.",
	// 			severity: "error",
	// 		});
	// 	} else {

	// 		setIsLoading(true);
	// 		try {
	// 			const response: any = await OffCyclePayrollService.createStubOffCyclePayrollPdfPrint(
	// 				selectedRowsValues,
	// 				clientId,
	// 			);
	// 			if (response.status === 400) {
	// 				setSnackbarData({
	// 					open: true,
	// 					message: response.data.message
	// 						? response.data.message
	// 						: "Something went wrong.",
	// 					// message: "Please Unmask sensitive data for PDF printing.",
	// 					severity: "error",
	// 				});
	// 			} else {
	// 				const filename = `EmailStubPrint.pdf`;
	// 				savePdfAsFile(response, filename);
	// 			}
	// 			setIsLoading(false);
	// 		} catch (err) {
	// 			alert(err);
	// 		}
	// 		setIsLoading(false);

	// 	}
	// };


	const onEmailStubCalculatedOffCyclePayrollButtonClicked = async (selectedItem: any) => {
		alert(selectedItem)
	};


	// const onSubmitCalculatedOffCyclePayrollButtonClickedHandler = () => {
	// 	const selectedoffCyclePayrollPeriodValue = formMethods.watch("offCyclePayrollPeriodsDDL");
	// 	if (selectedoffCyclePayrollPeriodValue && offCyclePayrollPeriodsDDL) {
	// 		const selectedOffCyclePayrollPeriod = offCyclePayrollPeriodsDDL && offCyclePayrollPeriodsDDL.find((x: any) => x.endDate === selectedoffCyclePayrollPeriodValue)
	// 		if (offCyclePayrollTableData && offCyclePayrollTableData.rowSelection) {
	// 			if (offCyclePayrollDataGridSelectedRows.length > 0) {
	// 				const updatePayloadData =
	// 					offCyclePayrollDataGridSelectedRows &&
	// 					offCyclePayrollDataGridSelectedRows.map((item: any) => ({
	// 						...item,
	// 						clientId: clientId,
	// 						payPeriod: selectedOffCyclePayrollPeriod.payPeriodCode,
	// 						payPeriodEndDate: payPeriodEndDate,
	// 						offCyclePayrollSheduleId: selectedPayPeriodId,
	// 					}));
	// 				savingCalculatdeOffCyclePayroll({
	// 					clientId,
	// 					data: { payrollData: updatePayloadData },
	// 					navigateToLogout: navigateToLogout
	// 				});
	// 			} else {
	// 				setSnackbarData({
	// 					open: true,
	// 					message: "Please select at least one employee!",
	// 					severity: "error"
	// 				})
	// 			}
	// 		} else {
	// 			const updatePayloadData =
	// 				calculatedOffCyclePayrollTableData &&
	// 				calculatedOffCyclePayrollTableData.map((item: any) => ({
	// 					...item,
	// 					clientId: clientId,
	// 					payPeriod: selectedOffCyclePayrollPeriod.payPeriodCode,
	// 					payPeriodEndDate: payPeriodEndDate,
	// 					offCyclePayrollSheduleId: selectedPayPeriodId,
	// 				}));
	// 			savingCalculatdeOffCyclePayroll({
	// 				clientId,
	// 				data: { payrollData: updatePayloadData },
	// 				navigateToLogout: navigateToLogout
	// 			});
	// 		}
	// 	}
	// };
	const onSubmitOrOverWriteCalculatedOffCyclePayrollButtonClickedHandler = (event: any) => {
		if (event === "Overwrite") {
			const selectedoffCyclePayrollPeriodValue = formMethods.watch("offCyclePayrollPeriodsDDL");
			const selectedoffCyclePayrollFrequencyValue = formMethods.watch("payFrequencyDDLItems");
			if (selectedoffCyclePayrollFrequencyValue && payFrequencyDDLItems) {
				const selectedOffCyclePayrollFrequency = payFrequencyDDLItems && payFrequencyDDLItems.find((x: any) => x.value === selectedoffCyclePayrollFrequencyValue)
				if (offCyclePayrollTableData && offCyclePayrollTableData.rowSelection) {
					if (calculatedOffCyclePayrollDataGridSelectedRows.length > 0) {
						const updatePayloadData =
							calculatedOffCyclePayrollDataGridSelectedRows &&
							calculatedOffCyclePayrollDataGridSelectedRows.map((item: any) => ({
								...item,
								clientId: clientId,
								payPeriod: selectedOffCyclePayrollFrequency.payPeriodCode,
								payPeriodEndDate: payPeriodEndDate,
								offCyclePayrollSheduleId: selectedPayPeriodId,
								paymentType: paymentType,
							}));

						overwriteCalculatdeOffCyclePayroll({
							clientId,
							data: { payrollData: updatePayloadData },
							navigateToLogout: navigateToLogout
						});
					} else {
						setSnackbarData({
							open: true,
							message: "Please select at least one employee!",
							severity: "error"
						})
					}
				} else {
					const updatePayloadData =
						calculatedOffCyclePayrollTableData &&
						calculatedOffCyclePayrollTableData.map((item: any) => ({
							...item,
							clientId: clientId,
							payPeriod: selectedOffCyclePayrollFrequency.payPeriodCode,
							payPeriodEndDate: payPeriodEndDate,
							offCyclePayrollSheduleId: selectedPayPeriodId,
							paymentType: paymentType,
						}));

					overwriteCalculatdeOffCyclePayroll({
						clientId,
						data: { payrollData: updatePayloadData },
						navigateToLogout: navigateToLogout
					});
				}
			}
		} else {
			const selectedoffCyclePayrollFrequencyValue = formMethods.watch("payFrequencyDDLItems");
			if (selectedoffCyclePayrollFrequencyValue && payFrequencyDDLItems) {
				const selectedOffCyclePayrollFrequency = payFrequencyDDLItems && payFrequencyDDLItems.find((x: any) => x.value === selectedoffCyclePayrollFrequencyValue)
				if (offCyclePayrollTableData && offCyclePayrollTableData.rowSelection) {
					if (calculatedOffCyclePayrollDataGridSelectedRows.length > 0) {
						const updatePayloadData =
							calculatedOffCyclePayrollDataGridSelectedRows &&
							calculatedOffCyclePayrollDataGridSelectedRows.map((item: any) => ({
								...item,
								clientId: clientId,
								payPeriod: selectedOffCyclePayrollFrequency.payPeriodCode,
								payPeriodEndDate: payPeriodEndDate,
								offCyclePayrollSheduleId: selectedPayPeriodId,
								paymentType: paymentType,
								checkDate: formatDate(item.checkDate),
							}));

						savingCalculatdeOffCyclePayroll({
							clientId,
							data: { payrollData: updatePayloadData },
							navigateToLogout: navigateToLogout
						});
					} else {
						setSnackbarData({
							open: true,
							message: "Please select at least one employee!",
							severity: "error"
						})
					}
				} else {
					const updatePayloadData =
						calculatedOffCyclePayrollTableData &&
						calculatedOffCyclePayrollTableData.map((item: any) => ({
							...item,
							clientId: clientId,
							payPeriod: selectedOffCyclePayrollFrequency.payPeriodCode,
							payPeriodEndDate: payPeriodEndDate,
							offCyclePayrollSheduleId: selectedPayPeriodId,
							paymentType: paymentType,
							checkDate: formatDate(item.checkDate),
						}));
					savingCalculatdeOffCyclePayroll({
						clientId,
						data: { payrollData: updatePayloadData },
						navigateToLogout: navigateToLogout
					});
				}
			}
		}
	};
	const onProcessOffCyclePayrollClicked = async () => {
		// (async () => {
		// 	let requestPayload = {
		// 		clientId: clientId,
		// paymentMethod: companyInfo.transactionMethod && companyInfo.transactionMethod === 100 ? 300 : 100,
		// 		province: companyInfo.address.province.id,
		// 		taxYear: taxYear,
		// 		payPeriodFrequencyId: selectedPayPeriodId,
		// 		payPeriodEndDate: payPeriodEndDate
		// 	}
		// 	try {
		// 		setIsLoading(true)
		// 		const response = await OffCyclePayrollService.process({ offCyclePayrollData: requestPayload });
		// 		if (response && response.status === 201) {
		(async () => {
			let requestPayload = {
				clientId: clientId,
				payPeriodFrequencyId: selectedPayPeriodId,
				paymentType: paymentType,
				payPeriodEndDate: payPeriodEndDate
			}
			try {
				setIsLoading(true)
				const response = await OffCyclePayrollService.directDeposit(requestPayload);
			} catch { } finally { setIsLoading(false) }
		})();
		return Promise.all([
			queryClient.invalidateQueries({
				queryKey: [LABALS_DDL_LIST_QUERY_KEY]
			}),
			queryClient.invalidateQueries({
				queryKey: [PAYROLL_PERIODS_DDL_LIST_QUERY_KEY, clientId, selectedPayPeriodId, taxYear, paymentType],
			}),
			queryClient.invalidateQueries({
				queryKey: [PAYROLL_LIST_QUERY_KEY, clientId,
					selectedPayPeriodId,
					paymentType,
					// payPeriodStarDate,
					// payPeriodEndDate,
					queryParamsOffCyclePayrollData,],
			}),
			queryClient.invalidateQueries({
				queryKey: [CALCULATED_PAYROLL_LIST_QUERY_KEY, clientId,
					selectedPayPeriodId,
					selectedLabel,
					paymentType,
					// payPeriodStarDate,
					// payPeriodEndDate,
					queryParamsCalculatedOffCyclePayrollData,],
			}),
		]);
		// } else {
		// 	setSnackbarData({
		// 		open: true,
		// 		message:
		// 			response && response.message && response.message
		// 				? response.message
		// 				: "Something went wrong.",
		// 		severity: "error",
		// 	});
		// }

		// } catch { } finally { setIsLoading(false) }
		// })();
	};
	const onCancelProcessOffCyclePayrollClicked = async () => {
		(async () => {
			let requestPayload = {
				clientId: clientId,
				// invoiceNo: storedInvoiceNoId,
				payPeriodEndDate: payPeriodEndDate,
				payPeriodFrequencyId: selectedPayPeriodId,
				paymentType: paymentType,
			}

			try {
				setIsLoading(true)
				const response = await OffCyclePayrollService.cancelProcess(requestPayload);
				if (response && response.status === 200) {
					return Promise.all([
						queryClient.invalidateQueries({
							queryKey: [LABALS_DDL_LIST_QUERY_KEY]
						}),
						queryClient.invalidateQueries({
							queryKey: [PAYROLL_PERIODS_DDL_LIST_QUERY_KEY, clientId, selectedPayPeriodId, taxYear, paymentType],
						}),
						queryClient.invalidateQueries({
							queryKey: [PAYROLL_LIST_QUERY_KEY, clientId,
								selectedPayPeriodId,
								paymentType,
								// payPeriodStarDate,
								// payPeriodEndDate,
								queryParamsOffCyclePayrollData,],
						}),
						queryClient.invalidateQueries({
							queryKey: [CALCULATED_PAYROLL_LIST_QUERY_KEY, clientId,
								selectedPayPeriodId,
								selectedLabel,
								paymentType,
								// payPeriodStarDate,
								// payPeriodEndDate,
								queryParamsCalculatedOffCyclePayrollData,],
						}),
					]);
				} else {
					setSnackbarData({
						open: true,
						message:
							response && response.message && response.message
								? response.message
								: "Something went wrong.",
						severity: "error",
					});
				}

			} catch { } finally { setIsLoading(false) }
		})();
	};

	const onClickImportPayrollDataHandler = () => {
		alert('Comming Soon..')
	}

	return (
		<>
			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}

				sx={{
					mt: "1.7rem"
				}}>
				<BackdropCircularProgress
					open={
						isPending ||
						isPendingOffCyclePayrollPeriodsDDL ||
						isSubmitting ||
						isPendingPayFrequencyDDL ||
						isPendingDepartmentDDL ||
						isPendingCalculatedOffCyclePayrollTableData ||
						isDeletingEmployeeOffCyclePayrollData ||
						isInsertingEmployeeOffCyclePayrollData ||
						loadingData ||
						isEditingCalculatdeOffCyclePayroll ||
						isSavingCalculatdeOffCyclePayroll ||
						isOverwriteCalculatdeOffCyclePayroll ||
						isPendingVocationalEarningsList ||
						isCalculatingOffCyclePayroll ||
						isPendingGetEmployeeDDLByStatus ||
						isLoadingAssignedEmployees ||
						isPendingLabelsDDL
						|| isPendingClientInformationById || isPendingGeneralSettingsInformationById
					}
					testId="offCyclePayroll-list"
				/>
				<DeleteConfirmationDialog
					open={openEmployeeOffCyclePayrollDataDialog}
					deleteActionHandler={deleteEmployeeOffCyclePayrollDataField}
					cancelActionHandler={onCloseEmployeeOffCyclePayrollDataDeleteHandler}
					testId="departments-confirmation-dialog"
				/>
				<FormProvider {...formMethods}>
					<form onSubmit={formMethods.handleSubmit(onSubmit)}>

						{/* OffCyclePayroll Non-Calculated Data Table */}
						<OffCyclePayrollSetupHeaderPanel
							payFrequencyDDLItems={payFrequencyDDLItems}
							onFrequencyChangeHandler={onFrequencyChangeHandler}
							offCyclePayrollPeriodsDDL={offCyclePayrollPeriodsDDL}
							// onOffCyclePayrollPeriodsDDLChangeHandler={onOffCyclePayrollPeriodsDDLChangeHandler}
							departmentsDDLItems={departmentsDDLItems}
							offCyclePayrollTableData={offCyclePayrollTableData}
							selectedpayPeriodIndex={selectedpayPeriodIndex}
							// payPeriodStarDate={payPeriodStarDate}
							payPeriodEndDate={payPeriodEndDate}
							showAddRemoveEmployees={showAddRemoveEmployees}
							onClickAddEmployeesHandler={onClickAddEmployeesHandler}
							taxYear={taxYear}
							onPayPeriodDateSelectionChangeHandler={onPayPeriodDateSelectionChangeHandler}
							selectedPayPeriodId={selectedPayPeriodId}
							selectedLabel={labelsDDL && labelsDDL.find((x: any) => x.value === formMethods.watch("labelDDL"))}
							labelsDDLItems={labelsDDLItems}
							onLabelSelectionChangeHandler={onLabelSelectionChangeHandler}
							onLabelChangeHandler={onLabelChangeHandler}
							onPaymentTypeChangeHandler={onPaymentTypeChangeHandler}
							calculatedOffCyclePayrollTableData={calculatedOffCyclePayrollTableData && calculatedOffCyclePayrollTableData.items}
							summary={calculatedOffCyclePayrollTableData && calculatedOffCyclePayrollTableData.summary}
							onClickImportPayrollDataHandler={onClickImportPayrollDataHandler}
							general_settings={general_settings}
						/>
						{offCyclePayrollTableData && offCyclePayrollTableData.items && offCyclePayrollTableData.items.length > 0 &&
							<OffCyclePayrollDataGrid
								columns={offCyclePayrollTableData ? offCyclePayrollTableData.headerColumns : []}
								rows={
									offCyclePayrollTableData && upadtedOffCyclePayrollItems
										? upadtedOffCyclePayrollItems
										: []
								}
								showIndexColumn={false}
								showChecboxColumn={offCyclePayrollTableData && offCyclePayrollTableData.rowSelection}
								// showSettingColumn={true}
								// onRowEditClicked={onRowEditClicked}
								// onRowDeleteClicked={onRowDeleteClicked}
								onSnackbarMessageData={(value: any) => setSnackbarData(value)}
								totalRecords={
									offCyclePayrollTableData && offCyclePayrollTableData.total
										? offCyclePayrollTableData.total
										: 0
								}
								initialPageSize={INITIAL_PAGE_SIZE}
								rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
								onRequestParamsChange={onRequestParamsChangeOffCyclePayrollData}
								selectionToolbar={selectionToolbar}
								selectedRowsValues={(value: any) => setSelectedRowsValues(value)}
								searchFieldPlaceholder={"Search..."}
								pageTitle={"OffCyclePayroll"}
								OffCyclePayrollTableData={(data: any) =>
									setOffCyclePayrollTableData(data)
								}
								tableMargin={"0"}
								tableScrollHeight={true}
								vocationalEarningsList={vocationalEarningsList}
							/>}

						{offCyclePayrollTableData && offCyclePayrollTableData.items && offCyclePayrollTableData.items.length > 0 && (
							<OffCyclePayrollSetupToolbar
								offCyclePayrollScreenPermissions={offCyclePayrollScreenPermissions}
								onSubmitButtonClickedHandler={onSubmitButtonClickedHandler}
								onCalculateOffCyclePayrollClicked={onCalculateOffCyclePayrollClicked}
								onInsertButtonClicked={onInsertButtonClicked}
								onDeleteEmployeeOffCyclePayrollDataClicked={onDeleteEmployeeOffCyclePayrollDataClicked}
								offCyclePayrollTableData={offCyclePayrollTableData && offCyclePayrollTableData}
								haveCalculatedTable={calculatedOffCyclePayrollTableData && calculatedOffCyclePayrollTableData.items && calculatedOffCyclePayrollTableData.items.length > 0 ? true : false} />
						)}

						{/* OffCyclePayroll Calculated Data Table */}
						<CalculatedOffCyclePayrollSetupHeaderPanel
							departmentsDDLItems={departmentsDDLItems}
							calculatedOffCyclePayrollTableData={calculatedOffCyclePayrollTableData}
						/>
						{calculatedOffCyclePayrollTableData && calculatedOffCyclePayrollTableData.items && calculatedOffCyclePayrollTableData.items.length > 0 &&
							<CalculatedOffCyclePayrollDataGrid
								columns={calculatedOffCyclePayrollTableData ? calculatedOffCyclePayrollTableData.headerColumns : []}
								rows={
									calculatedOffCyclePayrollTableData && upadtedCalculatedOffCyclePayrollItems
										? upadtedCalculatedOffCyclePayrollItems
										: []
								}
								showIndexColumn={false}
								showChecboxColumn={offCyclePayrollTableData && offCyclePayrollTableData.rowSelection}
								onSnackbarMessageData={(value: any) => setSnackbarData(value)}
								totalRecords={
									offCyclePayrollTableData && offCyclePayrollTableData.total
										? offCyclePayrollTableData.total
										: 0
								}
								initialPageSize={INITIAL_PAGE_SIZE}
								rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
								onRequestParamsChange={onRequestParamsChangeCalculatedOffCyclePayrollData}
								selectionToolbar={CalculatedOffCyclePayrollDataGridSelectionToolbar}
								selectedRowsValues={(value: any) => setSelectedRowsValues(value)}
								searchFieldPlaceholder={"Search..."}
								pageTitle={"OffCyclePayroll"}
								OffCyclePayrollTableData={(data: any) =>
									setOffCyclePayrollTableData(data)
								}
								tableMargin={"0"}
								tableScrollHeight={true}
							/>}

						{calculatedOffCyclePayrollTableData && calculatedOffCyclePayrollTableData.items && calculatedOffCyclePayrollTableData.items.length > 0 && (
							<CalculatedOffCyclePayrollSetupToolbar
								// onSubmitCalculatedOffCyclePayrollButtonClickedHandler={onSubmitCalculatedOffCyclePayrollButtonClickedHandler}
								onPrintCheckOrStubClaculatedOOffCyclePayrollButtonClickedHandler={onPrintCheckOrStubClaculatedOOffCyclePayrollButtonClickedHandler}
								onEditCalculatedOffCyclePayrollButtonClicked={onEditCalculatedOffCyclePayrollButtonClicked}
								onEmailStubCalculatedOffCyclePayrollButtonClicked={onEmailStubCalculatedOffCyclePayrollButtonClicked}
								onSubmitOrOverWriteCalculatedOffCyclePayrollButtonClickedHandler={onSubmitOrOverWriteCalculatedOffCyclePayrollButtonClickedHandler}
								onProcessOffCyclePayrollClicked={onProcessOffCyclePayrollClicked}
								onCancelProcessOffCyclePayrollClicked={onCancelProcessOffCyclePayrollClicked}
								offCyclePayrollNonCalculatedDataItems={offCyclePayrollTableData && offCyclePayrollTableData.items}
								selectedPayPeriod={labelsDDL && labelsDDL.find((x: any) => x.value === formMethods.watch("labelDDL"))}
								payPeriodEndDate={payPeriodEndDate}
								payPeriodStartDate={payPeriodStarDate}
								companyInfo={companyInfo}
								calculatedOffCyclePayrollTableData={calculatedOffCyclePayrollTableData}

							/>
						)}
					</form>
				</FormProvider>
			</Grid>


			{/* ADD EMPLOYEES DIALOGUE BOX */}
			<EnhancedDialog
				dialogMaxWidth={1250}
				dialogTitle="Employee(s)"
				key="Payroll Add Employees"
				testId="Payroll-Add-Employees"
				onCloseHandler={onCloseAddEmployeeHandler}
				open={addEmployee}
				dialogContent={
					<OffCyclePayrollAddEmployeePanel
						moveEmployeeFirstPanelSelectionToolbar={moveEmployeeFirstPanelSelectionToolbar}
						moveEmployeeSecondPanelSelectionToolbar={moveEmployeeSecondPanelSelectionToolbar}
						assignedAddEmployeeResponsePayload={assignedAddEmployeeResponsePayload}
						assignedAddEmployeeResponseData={assignedAddEmployeeResponseData}
						onMoveAssignEmployeeClicked={onMoveAssignEmployeeClicked}
						onMoveUnAssignedEmployeeClicked={onMoveUnAssignedEmployeeClicked}
						isLoadingAddEmployee={isLoadingAddEmployee}
						isLoadingRemoveEmployee={isLoadingRemoveEmployee}
						moveEmployeeFirstPanelItems={moveEmployeeFirstPanelItems}
						moveEmployeeSecondPanelItems={moveEmployeeSecondPanelItems}
					/>
				}
				showdividers={false}
				dialogAction={null}
			/>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
